exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions-container{display:flex;flex-direction:row;align-items:center}.actions-container .actions-caption{color:var(--aluminium);margin-right:.5rem}", ""]);

// exports
